var BacklogActions = (function () {
    function BacklogActions() {
        var _this = this;
        this.Constants = {
            UpdateFilterState: 'backlog/update_filter_state',
            SetActiveTab: 'backlog/set_active_tab',
            ResetCurrentTabFilters: 'backlog/reset_current_tab_filters',
            ResetAllDealsFilters: 'backlog/reset_all_deals_filters',
            ResetFilterState: 'backlog/reset_filter_state',
            SetVisibleColumns: 'backlog/set_visible_columns',
        };
        this.updateFilterState = function (data) {
            return {
                type: _this.Constants.UpdateFilterState,
                payload: data,
            };
        };
        this.setActiveTab = function (tabIndex) {
            return {
                type: _this.Constants.SetActiveTab,
                payload: tabIndex,
            };
        };
        this.resetCurrentTabFilters = function () {
            return {
                type: _this.Constants.ResetCurrentTabFilters,
            };
        };
        this.resetAllDealsFilters = function () {
            return {
                type: _this.Constants.ResetAllDealsFilters,
            };
        };
        this.resetFilterState = function () {
            return {
                type: _this.Constants.ResetFilterState,
            };
        };
        this.setVisibleColumns = function (visibleColumnKeys) {
            return {
                type: _this.Constants.SetVisibleColumns,
                payload: visibleColumnKeys,
            };
        };
    }
    return BacklogActions;
}());
export var backlog_actions = new BacklogActions();
